var _                      = require('underscore');
var $                      = require('jquery');
var Core                   = require('../core/core.js');

/**
 * Creates tray search bar
 *
 * @class
 */

class TraySearch extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'placeholder': 'Search'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <% if (enableFiltering) { %>
            <div class="editor__tray__tabs__top__btn__searchfilter">
                <a class="js-editor__tray__tabs__top__btn__searchfilter">
                    <%= embedded_svg("icon-filter.svg") %> <!-- TODO: change this. -->
                </a>
            </div>
            <% } %>
            <div class="editor__tray__tabs__top__search">
                <input class="editor__tray__tabs__top__search__input js-tray__tabs__top__search__input__value" type="text" placeholder="<%- placeholder %>"></input>
                <div class="editor__tray__tabs__top__search__btn__search">
                    <%= embedded_svg("icon-search.svg") %>
                </div>
                <div class="editor__tray__tabs__top__search__btn__clear hide">
                    <a class="js-editor__tray__tabs__top__search__btn__clear">
                        <%= embedded_svg("icon-close.svg") %>
                    </a>
                </div>
            </div>
        `;
     
        super.render();

        /**
         * Search input
         *
         * @fires TraySearch#_valuechanged
         */

        $('.js-tray__tabs__top__search__input__value', this.$el).on('input', this._valuechanged);

        /**
         * Clear clicked
         *
         * @fires TraySearch#_clearClicked
         */

        var self = this;

        $('.js-editor__tray__tabs__top__search__btn__clear', this.$el).on('click', function(){
            self._clearClicked(self);
        });
     
        /**
         * Toggle search filters.
         *
         * @fires TraySearch#_filterClicked
         */
         if (this._options.fields['enableFiltering'])
             $('.js-editor__tray__tabs__top__btn__searchfilter', this.$el).on('click', this._filterClicked);
    }

    /**
     * Makes the tray search visible
     */

    show(){
        this.$el.show();
    }

    /**
     * Makes the tray search invisible
     */

    hide(){
        this.$el.hide();
    }

    /**
     * @event TraySearch#Cioui:TraySearch:value
     * @property {String}Cioui:TraySearch:value
     * @returns {String} value - the new text input obj
     */

    _valuechanged(e){
        $(e.currentTarget).trigger('Cioui:TraySearch:value', $(e.currentTarget).val());
    }

    /**
     * Fires when user clicks clear
     */

    _clearClicked(ref){
        $('.js-tray__tabs__top__search__input__value', ref.$el).val("").trigger("input");
    }

    /**
     * @event TraySearch#Cioui:TraySearch:filterClicked
     * @property {String}Cioui:TraySearch:value
     * @returns {String} value - the new text input obj
     */

    _filterClicked(e){
        $(e.currentTarget).trigger('Cioui:TraySearch:filterClicked', e);
    }

}
module.exports = TraySearch;
